export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-queue/index.js
// module id = ../../../../d3-queue/index.js
// module chunks = vendor